import { StyledSvg } from "baseui/icon";
import React from "react";

export const TailwindCSSTemplateIcon = (props: React.ComponentProps<typeof StyledSvg>) => (
  <StyledSvg width="21" height="20" viewBox="0 0 21 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M0.332031 4C0.332031 1.79086 2.12289 0 4.33203 0H16.332C18.5412 0 20.332 1.79086 20.332 4V16C20.332 18.2091 18.5412 20 16.332 20H4.33203C2.12289 20 0.332031 18.2091 0.332031 16V4Z"
      fill="#F2F2FF"
    />
    <path
      d="M10.332 6C8.46536 6 7.2987 6.88883 6.83203 8.66648C7.53203 7.77765 8.3487 7.44452 9.28203 7.66652C9.81461 7.79321 10.1952 8.16136 10.6167 8.56868C11.3027 9.2319 12.0969 9.99986 13.832 9.99986C15.6987 9.99986 16.8654 9.11103 17.332 7.3331C16.632 8.22193 15.8154 8.55534 14.882 8.33335C14.3497 8.20665 13.9691 7.8385 13.5477 7.43118C12.8614 6.76769 12.0669 6 10.332 6ZM6.83203 9.99986C4.96536 9.99986 3.7987 10.8887 3.33203 12.6666C4.03203 11.7778 4.8487 11.4444 5.78203 11.6667C6.31432 11.7936 6.69495 12.1615 7.11641 12.5685C7.8027 13.232 8.5972 14 10.332 14C12.1987 14 13.3654 13.1112 13.832 11.3332C13.132 12.2221 12.3154 12.5555 11.382 12.3332C10.8494 12.2065 10.4688 11.8384 10.0474 11.4313C9.36136 10.7678 8.56716 9.99986 6.83203 9.99986Z"
      fill="#4242FC"
    />
  </StyledSvg>
);
